import templateComponents from '../../../Template/config/components'
import selection from './selection'
import scorecard from './scorecard'

export default {
  ...templateComponents,
  selection,
  scorecard,
}



// WEBPACK FOOTER //
// ./src/app/configuration/Audible/config/components/index.js